var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { BaseCoordinator, injectable } from '@serviceos-rn/core';
import { TipRoutes } from './TipRoutes';
let Coordinator = class Coordinator extends BaseCoordinator {
    dismissTip() {
        this.dismiss();
        this.dismiss();
    }
    getIsTipModal() {
        return this.getIsShowedRoute(TipRoutes.TipModal);
    }
    showToTip() {
        return this.navigate(TipRoutes.TipModal);
    }
    navigateToTip(mode = 'normal') {
        if (mode === 'compact') {
            return this.navigate(TipRoutes.TipCompact);
        }
        return this.navigate(TipRoutes.TipNormal);
    }
    navigateToStatus() {
        return this.navigate(TipRoutes.TipStatus);
    }
};
Coordinator = __decorate([
    injectable()
], Coordinator);
export { Coordinator };
